import { isMobile } from '@/lib/device'
import i18n from '@/lib/language'

export default [
  {
    path: 'record/worklog',
    name: 'recorLog',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/record/WorkLog`)
        : import(/* webpackChunkName: "pc-base" */ `@/pc/record/WorkLog`),
    meta: { title: i18n.t('message["1273"]') }
  },
  {
    path: 'record/notice',
    name: 'recordNotice',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/record/NoticeRecord`)
        : import(/* webpackChunkName: "pc-base" */ `@/pc/record/NoticeRecord`),
    meta: { title: i18n.t('message["1216"]') }
  }
]
